import React from 'react';
import { removeCreativeItemRow } from 'modules/campaigns/modules/campaigns-reports/actions';
import {
    deleteLibraryCreativeError,
    deleteLibraryCreativeSuccess,
    requestDeleteLibraryCreative,
} from 'modules/creative-library/actions';
import { INDICATION_TYPES, addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { creativesLibraryApi } from 'services/api';
import { errorMessagesUtils } from 'services/utils';

const successIndication = {
    message: <FormattedMessage id="creative-library.delete.success" defaultMessage="Creatives deleted successfully" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: (
        <FormattedMessage id="creatives-library.delete.error.highlight" defaultMessage="Unable to delete creatives." />
    ),
});

export const deleteLibraryCreative = data => dispatch => {
    const { accountName, id } = data;

    dispatch(requestDeleteLibraryCreative());

    return creativesLibraryApi
        .deleteLibraryCreative(accountName, id)
        .then(creativeLibraryItem => {
            dispatch(addIndication(successIndication));
            dispatch(deleteLibraryCreativeSuccess(creativeLibraryItem));
            dispatch(removeCreativeItemRow(id));
        })
        .catch(error => {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(deleteLibraryCreativeError(error));
        });
};
